import axios from '../config/axios'

export const getProperties = async (filter?: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties", {
            params: filter
        });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getFeaturedProperties = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/featured", {
            params: filter
        });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getTrendingProperties = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/trending", {
            params: filter
        });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getUpcomingProperties = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/offplan", {
            params: filter
        });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getLocalities = async (filter?: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/localities", {
            params: filter
        });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getDevelopers = async (filter?: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/developer", {
            params: filter
        });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const createProperty = async (propertyData: FormData) => {
    try {
        const response = await axios.post("/api/properties/add-property", propertyData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getBrokerProperties = async (filter?: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/properties/brokerproperties", {
            params: filter
        });
        return {
            data: response.data?.data,
            paginationData: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getBrokerPropertyStats = async () => {
    try {
        const response = await axios.get("/api/properties/brokerproperties/stats");
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const deleteProperty = async (id: string) => {
    try {
        const response = await axios.delete(`/api/properties/${id}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getPropertyById = async (id: string) => {
    try {
        const response = await axios.get(`/api/properties/${id}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updateProperty = async (id: string, propertyData: FormData) => {
    try {
        const response = await axios.put(`/api/properties/${id}`, propertyData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAdminPropertyStats = async () => {
    try {
        const response = await axios.get('/api/admin/AllPropertiesStats');
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAdminProperties = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get('/api/admin/AllProperties', { params: filter });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updatePropertyStatus = async (id: string, status: "PUBLISHED" | "REJECTED") => {
    try {
        const response = await axios.put(`/api/admin/properties/${id}/status`, { status });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getPropertyBySlug = async (slug: string) => {
    try {
        const response = await axios.get(`/api/properties/title/${slug}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};
export const updatePropertyTrending = async (id: string, trending: boolean) => {
    try {
        const response = await axios.put(`/api/admin/properties/${id}/trending`, { trending });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updatePropertyFeatured = async (id: string, featured: boolean) => {
    try {
        const response = await axios.put(`/api/admin/properties/${id}/featured`, { featured });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getDeveloperProperties = async (developer: string, filter: { [key: string]: any }) => {
    try {
        const response = await axios.get(`/api/properties/developer/${encodeURIComponent(developer)}`, { params: filter });
        return {
            data: response.data?.data,
            pagination: response.data?.pagination
        }
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getPropertiesGroupedByField = async (field: string) => {
    try {
        const response = await axios.get(`/api/properties/group-by/${field}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getPropertiesByLocation = async (locality: string) => {
    try {
        const response = await axios.get(`/api/properties/location/${encodeURIComponent(locality)}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};
